var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$i18n.locale == 'ar')?_c('img',{staticClass:"imgs",attrs:{"src":require("../../assets/mes_ar.png"),"alt":""}}):_c('img',{staticClass:"imgs",attrs:{"src":require("../../assets/mes_en.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }